export default __webpack_public_path__ + "static/media/ic_dai_40.6f901476.svg";